import { Routes, Route, Navigate } from 'react-router-dom'
import Navbar from 'components/cards/navbar'
import Footer from 'components/cards/footer'
import Home from './home'
import Services from './services'
import Institutes from './institute'
import Application from './application'
import About from './about'
import Account from './account'
import Housing from './housing'
import BlogList from './BlogList'
import TestimonialList from './TestimonialList'
import SearchPrograms from './program'
import StudentCommitment from './policies/student-commitment'
import AdmissionsDisclaimer from './policies/admissions-disclaimer'
import Fees from './policies/fees'
import Payments from './policies/payments'
import Complaints from './policies/complaints'
import PrivacyPolicy from './policies/privacy-policy'
import ProfessionalStandards from './policies/professional-standards'

export default function WebPages() {
  const badgeStyle = {
    position: 'fixed',
    right: '20px',
    top: '90%',
    backgroundColor: '#ffffff',
    color: 'white',
    padding: '10px 15px',
    borderRadius: '10px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
    zIndex: 1000,
    textDecoration: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
  }
  return (
    <>
      <Navbar />
      <a href='https://uhdss-utravel-agency.netlify.app/' target='blank' style={badgeStyle}>
        Book for Accommodation Now
      </a>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/services' element={<Services />} />
        <Route path='/our-services' exact element={<Navigate to='/services' />} />
        <Route path='/institutes/*' element={<Institutes />} />
        <Route path='/apply/*' element={<Application />} />
        <Route path='/apply-for-education-services' exact element={<Navigate to='/account?reqapp=true' />} />
        <Route path='/about' element={<About />} />
        <Route path='/about-us' exact element={<Navigate to='/about' />} />
        <Route path='/account/*' element={<Account />} />
        <Route path='/housing' element={<Housing />} />
        <Route path='/program' element={<SearchPrograms />} />
        <Route path='/blog' element={<><BlogList /> <TestimonialList /></>} />
        <Route path='/book-accommodation' element={<Housing />} />

        {/* Student protection and compliance */}
        <Route path='/student-commitment' element={<StudentCommitment />} />
        <Route path='/counselling-charter' exact element={<Navigate to='/student-commitment' />} />
        <Route path='/admissions-disclaimer' element={<AdmissionsDisclaimer />} />
        <Route path='/fees' element={<Fees />} />
        <Route path='/payments' element={<Payments />} />
        <Route path='/complaints' element={<Complaints />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/professional-standards' element={<ProfessionalStandards />} />
      </Routes>
      <Footer />
    </>
  )
}